const vaccineBooking = {
  title: 'Book an Appointment for Our Onsite Services',
  note: 'You will be forwarded to our service partner\'s booking form',
  bookAppointment: 'book appointment now',
  selectAppointment: 'Select appointment type',
}

export default vaccineBooking
